(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceResponseDeleteController',TreatmentExperienceResponseDeleteController);

    TreatmentExperienceResponseDeleteController.$inject = ['$uibModalInstance', 'entity', 'TreatmentExperienceResponse'];

    function TreatmentExperienceResponseDeleteController($uibModalInstance, entity, TreatmentExperienceResponse) {
        var vm = this;

        vm.treatmentExperienceResponse = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TreatmentExperienceResponse.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
